import { URLParserBase } from '@mdd/api';

export const environment = {
    production: false,
    postHogEnabled: false,
    posthogApiKey: 'phc_yC7pmGrDsyLjBhN98iZCwoy8muzDuarUg0yas7C7Eem',
    barchartApiKey: 'e1e7b7d8187322d75e97b1c91fa2839d', // For local development, use the BARCHART_API_KEY environment variable key here. This file is ignored by git.
    googleApiKey: '',
    apiBase: <URLParserBase>{
        protocol: 'https',
        host: 'test.mydairydashboard.com',
        href: 'https://test.mydairydashboard.com'
    }
};
